import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faSave,
  faTimes,
  faPen,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import {
  electricityLoadDeposit,
  airConditioingLoadDeposit,
  meterDeposit,
  gasBasisUnitsGasBank,
  storageFitoutDeposit,
} from "../../constants";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getToDate } from "../../utils/utils";
import { Modal } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import {
  periodOneMileStoneNames,
  periodOtherMilestoneNames,
} from "../../constants";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
import { formatTwoDecimal } from "../../utils/index";
class OtherDepositDetails extends React.Component {
  countError = "";
  state = {
    odepMilestonePercent: 100,
    currentIndex: null,
    disableOnEdit: false,
    readOnEdit: false,
    applicableValue: "",
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: "",
    index_val: "",
    delete: false,
    keyvalue: "",
    leaseCommencementDate: "",
    popupData: {},
    isOpen: false,
    milestoneMonths: "ODEP Milestone # Months",
    showForm: true,
    fromDate: "",
    toDate: "",
    leaseTermDD: "",
    leaseTermMM: "",
    leaseTermYY: "",
    periodTermDD: "",
    periodTermMM: "",
    periodTermYY: "",
    renewalLeaseTermDD: "",
    renewalLeaseTermMM: "",
    renewalLeaseTermYY: "",
    period: 1,
    redirect: false,
    milestonesCount: 1,
    milestones: [],
    milestoneNamesValues: [],
    depositRateUomValues: [],
    initialValues: {
      odepLogic: {
        milestones: [],
        period: "",
        otherDepositName: "",
        depositNature: "",
        fromDate: "",
        toDate: "",
        rateUOM: "",
        uom: "",
        onArea: "",
        milestonesCount: 0,
        onUnits: "",
        amount: "",
        rate: "",
        other_deposit_type: "",
      },
    },
    otherDepositDetails: [],
    toggleOdForm: false,
    toggleOnUnit: true,
    toggleStorage: false,
    showArea: false,
    showOnArea: false,
  };

  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        countError: "Validation has failed!", // will override all messages
      },
    });

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

    this.applicableValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  showOdForm = (e) => {
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (e.target.value === "yes") {
      this.setState({
        toggleOdForm: true,
      });
    } else {
      this.setState({
        toggleOdForm: false,
      });
    }
  };

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  componentDidMount() {

    let athis= this;
    axios.get(`${apiUrl.apiUrl.url}/create-lease/fetch-lease-other-deposit-details?id=${this.props.match.params.id}`).then((response) =>{
      let data = response.data;
      athis.state.applicableValue = data.otherDepositApplicable;
      athis.state.fromDate = data.from;
      athis.state.leaseCommencementDate = data.lcd;
      athis.state.renewalLeaseTermYY = data.renewalLeaseTermYY;
      athis.state.renewalLeaseTermDD = data.renewalLeaseTermDD;
      athis.state.renewalLeaseTermMM = data.renewalLeaseTermMM;

      if (data.otherDepositDetails.length > 0) {
        // let _tempDate = new Date(
        //   data.otherDepositDetails[data.otherDepositDetails.length - 1].toDate
        // );
        // _tempDate.setDate(_tempDate.getDate() + 1);
        // var dd = ("0" + _tempDate.getDate()).slice(-2);
        // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
        // var y = _tempDate.getFullYear();
        // var someFormattedDate = y + "-" + mm + "-" + dd;
        // athis.state.fromDate = someFormattedDate;
        athis.setState({
          fromDate: getToDate(
            data.otherDepositDetails[data.otherDepositDetails.length - 1]
              .toDate,
            2,
            0,
            0
          ),
        });
      }
      if (data.otherDepositApplicable === "yes") {
        athis.setState({
          toggleOdForm: true,
        });
      } else {
        athis.setState({
          toggleOdForm: false,
        });
      }
      athis.setState({
        initialValues: data,
        otherDepositDetails: data.otherDepositDetails,
        leaseTermDD: data.leaseTermDD,
        leaseTermMM: data.leaseTermMM,
        leaseTermYY: data.leaseTermYY,
        notes_13: data.notes_13,
        period:
          data.otherDepositDetails.length > 0
            ? data.otherDepositDetails.length + 1
            : 1,
      });
      var _intialValues = athis.state.initialValues;
      _intialValues.odepLogic = {
        milestones: [
          {
            dueDate: "",
            milestoneName: "",
            amount: "",
            milestonePercent: "",
          },
        ],
        period: "",
        otherDepositName: "",
        depositNature: "",
        fromDate: "",
        toDate: "",
        rateUOM: "",
        uom: "",
        onArea: "",
        milestonesCount: 0,
        onUnits: "",
        amount: "",
        rate: "",
      };
      athis.setState({
        initialValues: _intialValues,
      });
      if (
        data.otherDepositDetails[data.otherDepositDetails.length - 1]
          .toDate == data.to
      ) {
        athis.setState({
          showForm: false,
        });
      }
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-other-deposit-details?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.state.applicableValue = data.otherDepositApplicable;
    //     this.state.fromDate = data.from;
    //     this.state.leaseCommencementDate = data.lcd;
    //     this.state.renewalLeaseTermYY = data.renewalLeaseTermYY;
    //     this.state.renewalLeaseTermDD = data.renewalLeaseTermDD;
    //     this.state.renewalLeaseTermMM = data.renewalLeaseTermMM;

    //     if (data.otherDepositDetails.length > 0) {
    //       // let _tempDate = new Date(
    //       //   data.otherDepositDetails[data.otherDepositDetails.length - 1].toDate
    //       // );
    //       // _tempDate.setDate(_tempDate.getDate() + 1);
    //       // var dd = ("0" + _tempDate.getDate()).slice(-2);
    //       // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
    //       // var y = _tempDate.getFullYear();
    //       // var someFormattedDate = y + "-" + mm + "-" + dd;
    //       // this.state.fromDate = someFormattedDate;
    //       this.setState({
    //         fromDate: getToDate(
    //           data.otherDepositDetails[data.otherDepositDetails.length - 1]
    //             .toDate,
    //           2,
    //           0,
    //           0
    //         ),
    //       });
    //     }
    //     if (data.otherDepositApplicable === "yes") {
    //       this.setState({
    //         toggleOdForm: true,
    //       });
    //     } else {
    //       this.setState({
    //         toggleOdForm: false,
    //       });
    //     }
    //     this.setState({
    //       initialValues: data,
    //       otherDepositDetails: data.otherDepositDetails,
    //       leaseTermDD: data.leaseTermDD,
    //       leaseTermMM: data.leaseTermMM,
    //       leaseTermYY: data.leaseTermYY,
    //       notes_13: data.notes_13,
    //       period:
    //         data.otherDepositDetails.length > 0
    //           ? data.otherDepositDetails.length + 1
    //           : 1,
    //     });
    //     var _intialValues = this.state.initialValues;
    //     _intialValues.odepLogic = {
    //       milestones: [
    //         {
    //           dueDate: "",
    //           milestoneName: "",
    //           amount: "",
    //           milestonePercent: "",
    //         },
    //       ],
    //       period: "",
    //       otherDepositName: "",
    //       depositNature: "",
    //       fromDate: "",
    //       toDate: "",
    //       rateUOM: "",
    //       uom: "",
    //       onArea: "",
    //       milestonesCount: 0,
    //       onUnits: "",
    //       amount: "",
    //       rate: "",
    //     };
    //     this.setState({
    //       initialValues: _intialValues,
    //     });
    //     if (
    //       data.otherDepositDetails[data.otherDepositDetails.length - 1]
    //         .toDate == data.to
    //     ) {
    //       this.setState({
    //         showForm: false,
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  calculateToDate() {
    this.setState({
      toDate: getToDate(
        this.state.fromDate,
        this.state.periodTermDD,
        this.state.periodTermMM,
        this.state.periodTermYY
      ),
    });
  }

  getDepositName(e, values, setFieldValue) {
    if (
      this.state.otherDepositDetails[e.target.value] !== undefined &&
      this.state.otherDepositDetails[e.target.value].length > 0 &&
      this.state.otherDepositDetails[e.target.value][
        this.state.otherDepositDetails[e.target.value].length - 1
      ].toDate == values.to
    ) {
      setFieldValue("odepLogic.rentDepositNature", "");
      // alert("Values For this type has completed the period");
      this.setState({
        popupalertMessage: true,
        popupMessageContent: "Values For this type has completed the period",
      });
      return false;
    }
    if (
      e.target.value === "Storage Deposit" ||
      e.target.value === "Fitout Deposit" ||
      e.target.value === "Other"
    ) {
      this.setState({ toggleOnUnit: false, toggleStorage: true });
    } else {
      this.setState({ toggleOnUnit: true, toggleStorage: false });
    }
    if (e.target.value === "Storage Deposit") {
      this.setState({ showArea: true });
    } else {
      this.setState({ showArea: false });
    }
    if (e.target.value === "Fitout Deposit") {
      this.setState({ showOnArea: true });
    } else {
      this.setState({ showOnArea: false });
    }
    if (
      e.target.value === "Electricity Load Deposit – Refundable" ||
      e.target.value == "Electricity Load Deposit – Non Refundable"
    ) {
      this.setState({
        depositRateUomValues: electricityLoadDeposit,
      });
    } else if (
      e.target.value === "GAS / PNG Connection Deposit" ||
      e.target.value === "GAS / PNG Meter"
    ) {
      this.setState({
        depositRateUomValues: gasBasisUnitsGasBank,
      });
    } else if (
      e.target.value === "Electricity Meter Deposit" ||
      e.target.value === "Water Meter Deposit" ||
      e.target.value === "Air Conditioning Meter Deposit"
    ) {
      this.setState({
        depositRateUomValues: meterDeposit,
      });
    } else if (e.target.value === "Air Conditioing Load Deposit") {
      this.setState({
        depositRateUomValues: airConditioingLoadDeposit,
      });
    } else if (
      e.target.value === "Fitout Deposit" ||
      e.target.value === "Other"
    ) {
      this.setState({
        depositRateUomValues: storageFitoutDeposit,
      });
    } else if (e.target.value === "Storage Deposit") {
      this.setState({
        depositRateUomValues: storageFitoutDeposit,
      });
    } else {
      this.setState({
        depositRateUomValues: [],
      });
    }
    var _otherDepositDetails = this.state.otherDepositDetails;
    if (
      _otherDepositDetails[e.target.value] == undefined ||
      _otherDepositDetails[e.target.value].length == 0
    ) {
      this.state.fromDate = values.from;
      this.state.toDate = "";
      this.state.period = 1;
    } else {
      this.state.fromDate = getToDate(
        _otherDepositDetails[e.target.value][
          _otherDepositDetails[e.target.value].length - 1
        ].toDate,
        2,
        0,
        0
      );
      this.state.toDate = "";
      this.state.period =
        this.state.otherDepositDetails[e.target.value].length + 1;
      // values.odepLogic.period =
      //   this.state.otherDepositDetails[e.target.value].length + 1;
    }
    this.setState({});
    if (this.state.period == "1") {
      this.setState({
        milestoneNamesValues: periodOneMileStoneNames,
        milestoneMonths: "ODEP Milestone %",
      });
    } else {
      this.setState({
        milestoneNamesValues: periodOtherMilestoneNames,
        milestoneMonths: "ODEP Milestone %",
      });
    }
    return true;
  }

  editOd(index, values, key) {
    console.log(this.state.otherDepositDetails[key][index]);
    this.state.currentIndex = index;
    this.state.disableOnEdit = true;
    this.state.readOnEdit = true;
    this.state.period = this.state.otherDepositDetails[key][index].period;
    if (
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "Storage Deposit" ||
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "Fitout Deposit"
    ) {
      this.setState({ toggleOnUnit: false, toggleStorage: true });
    } else {
      this.setState({ toggleOnUnit: true, toggleStorage: false });
    }
    if (
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "Storage Deposit"
    ) {
      this.setState({ showArea: true });
    } else {
      this.setState({ showArea: false });
    }
    if (
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "Fitout Deposit"
    ) {
      this.setState({ showOnArea: true });
    } else {
      this.setState({ showOnArea: false });
    }
    if (this.state.otherDepositDetails[key][index].period === 1) {
      this.setState({
        milestoneNamesValues: periodOneMileStoneNames,
      });
    } else {
      this.setState({
        milestoneNamesValues: periodOtherMilestoneNames,
      });
    }
    this.setState({
      showForm: true,
      showAddBtn: true,
      periodTermDD: this.state.otherDepositDetails[key][index].periodTermDD,
      periodTermMM: this.state.otherDepositDetails[key][index].periodTermMM,
      periodTermYY: this.state.otherDepositDetails[key][index].periodTermYY,
    });
    this.state.milestonesCount =
      this.state.otherDepositDetails[key][index].milestones.length;
    this.state.fromDate = this.state.otherDepositDetails[key][index].fromDate;
    this.state.toDate = this.state.otherDepositDetails[key][index].toDate;
    values.odepLogic.otherDepositName =
      this.state.otherDepositDetails[key][index].otherDepositName;
    values.odepLogic.depositNature =
      this.state.otherDepositDetails[key][index].depositNature;
    values.odepLogic.months = this.state.otherDepositDetails[key][index].months;

    values.odepLogic.onUnits =
      this.state.otherDepositDetails[key][index].onUnits;
    values.odepLogic.amount = this.state.otherDepositDetails[key][index].amount;
    values.odepLogic.rate = this.state.otherDepositDetails[key][index].rate;
    values.odepLogic.totalAmount =
      this.state.otherDepositDetails[key][index].totalAmount;
    if (
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "Electricity Load Deposit – Refundable" ||
      this.state.otherDepositDetails[key][index].otherDepositName ==
      "Electricity Load Deposit – Non Refundable"
    ) {
      this.setState({
        depositRateUomValues: electricityLoadDeposit,
      });
    } else if (
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "GAS / PNG Connection Deposit" ||
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "GAS / PNG Meter"
    ) {
      this.setState({
        depositRateUomValues: gasBasisUnitsGasBank,
      });
    } else if (
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "Electricity Meter Deposit" ||
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "Water Meter Deposit" ||
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "Air Conditioning Meter Deposit"
    ) {
      this.setState({
        depositRateUomValues: meterDeposit,
      });
    } else if (
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "Air Conditioing Load Deposit"
    ) {
      this.setState({
        depositRateUomValues: airConditioingLoadDeposit,
      });
    } else if (
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "Fitout Deposit"
    ) {
      this.setState({
        depositRateUomValues: storageFitoutDeposit,
      });
    } else if (
      this.state.otherDepositDetails[key][index].otherDepositName ===
      "Storage Deposit"
    ) {
      this.setState({
        depositRateUomValues: storageFitoutDeposit,
      });
    } else {
      this.setState({
        depositRateUomValues: [],
      });
    }
    values.odepLogic.rateUOM =
      this.state.otherDepositDetails[key][index].rateUOM;
    values.odepLogic.area = this.state.otherDepositDetails[key][index].area;
    values.odepLogic.onArea = this.state.otherDepositDetails[key][index].onArea;
    values.odepLogic.monthsCount =
      this.state.otherDepositDetails[key][index].monthsCount;
    for (
      let i = 0;
      i < this.state.otherDepositDetails[key][index].milestones.length;
      i++
    ) {
      // if (this.state.milestones === undefined) {
      this.state.milestones[i] = {};
      values.odepLogic.milestones[i] = {};
      this.state.milestones[i].milestoneName =
        this.state.otherDepositDetails[key][index].milestones[i].milestoneName;
      values.odepLogic.milestones[i].milestoneName =
        this.state.otherDepositDetails[key][index].milestones[i].milestoneName;
      this.state.milestones[i].dueDate =
        this.state.otherDepositDetails[key][index].milestones[i].dueDate;
      values.odepLogic.milestones[i].dueDate =
        this.state.otherDepositDetails[key][index].milestones[i].dueDate;
      this.state.milestones[i].milestonePercent =
        this.state.otherDepositDetails[key][index].milestones[
          i
        ].milestonePercent;
      values.odepLogic.milestones[i].milestonePercent =
        this.state.otherDepositDetails[key][index].milestones[
          i
        ].milestonePercent;
      this.state.milestones[i].amount =
        formatTwoDecimal(this.state.otherDepositDetails[key][index].milestones[i].amount);
      values.odepLogic.milestones[i].amount =
        formatTwoDecimal(this.state.otherDepositDetails[key][index].milestones[i].amount) ;
      if (
        this.state.otherDepositDetails[key][index].milestones[
          i
        ].milestoneName.includes("Escalation")
      ) {
        this.state.milestones[i].milestoneQuantityType = "ODEP Milestone %";
        values.odepLogic.milestones[i].milestoneQuantityType =
          "ODEP Milestone %";
      } else {
        this.state.milestones[i].milestoneQuantityType =
          "ODEP Milestone # Months";
        values.odepLogic.milestones[i].milestoneQuantityType =
          "ODEP Milestone # Months";
      }
      this.setState({});
      // }
    }

    this.setState({});
  }

  addDetails = (values, resetForm) => {
    if (this.state.currentIndex === null) {
      if (this.state.period > 1) {
        this.state.milestones[0].milestonePercent = 100;
        values.odepLogic.milestones[0].milestonePercent = 100;
        this.setState({});
      }
      if (!this.validator.allValid()) {
        this.validator.showMessages();
        return false;
      }
      var totalMilestoneAmount = 0;
      for (let i = 0; i < this.state.milestones.length; i++) {
        console.log(this.state.milestones);
        totalMilestoneAmount += Number(this.state.milestones[i].amount);
      }
      if (this.state.period == "1") {
        if (formatTwoDecimal(totalMilestoneAmount) != formatTwoDecimal(values.odepLogic.amount) ) {
          this.setState({
            popupalertMessage: true,
            popupMessageContent:
              "Total Amount of Milestones do not match with total amount of period",
          });
          return false;
        }
      } else {
        var previousAmount =
          this.state.otherDepositDetails[values.odepLogic.otherDepositName][
            this.state.otherDepositDetails[values.odepLogic.otherDepositName]
              .length - 1
          ].amount;
        var currentAmount = values.odepLogic.amount;
        var balanceAmount = currentAmount - previousAmount;
      }
      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        return false;
      }
      var _otherDepositDetails = this.state.otherDepositDetails;
      values.odepLogic.period = this.state.period;
      values.odepLogic.fromDate = this.state.fromDate;
      values.odepLogic.toDate = this.state.toDate;
      values.odepLogic.periodTermYY = this.state.periodTermYY;
      values.odepLogic.periodTermMM = this.state.periodTermMM;
      values.odepLogic.periodTermDD = this.state.periodTermDD;
      if (
        _otherDepositDetails[values.odepLogic.otherDepositName] == undefined
      ) {
        _otherDepositDetails[values.odepLogic.otherDepositName] = [];
      }
      _otherDepositDetails[values.odepLogic.otherDepositName].push({
        ...values.odepLogic,
      });
      this.setState({
        otherDepositDetails: _otherDepositDetails,
      });
      this.state.periodTermDD = 0;
      this.state.periodTermMM = 0;
      this.state.periodTermYY = 0;
      this.state.fromDate = "";
      this.state.toDate = "";
      this.state.period++;
      this.state.milestonesCount = 1;
      resetForm();
      this.validator.hideMessages();
      this.state.milestones = [];
    } else {
      if (!this.validator.allValid()) {
        this.validator.showMessages();
        return false;
      }
      var totalMilestoneAmount = 0;
      for (let i = 0; i < values.odepLogic.milestones.length; i++) {
        totalMilestoneAmount += Number(this.state.milestones[i].amount);
      }
      if (this.state.period == "1") {
        if (formatTwoDecimal(totalMilestoneAmount) != formatTwoDecimal(values.odepLogic.amount)) {
          this.setState({
            popupalertMessage: true,
            popupMessageContent:
              "Total Amount of Milestones do not match with total amount of period",
          });
          return false;
        }
      } else {
        var previousAmount =
          this.state.otherDepositDetails[values.odepLogic.otherDepositName][
            this.state.otherDepositDetails[values.odepLogic.otherDepositName]
              .length - 1
          ].amount;
        var currentAmount = values.odepLogic.amount;
        var balanceAmount = currentAmount - previousAmount;
      }
      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        return false;
      }
      var _otherDepositDetails = this.state.otherDepositDetails;
      values.odepLogic.period = this.state.period;
      values.odepLogic.fromDate = this.state.fromDate;
      values.odepLogic.toDate = this.state.toDate;
      values.odepLogic.periodTermYY = this.state.periodTermYY;
      values.odepLogic.periodTermMM = this.state.periodTermMM;
      values.odepLogic.periodTermDD = this.state.periodTermDD;
      console.log(this.state.otherDepositDetails);
      if (
        _otherDepositDetails[values.odepLogic.otherDepositName] == undefined
      ) {
        _otherDepositDetails[values.odepLogic.otherDepositName] = [];
      }
      _otherDepositDetails[values.odepLogic.otherDepositName][
        this.state.currentIndex
      ] = { ...values.odepLogic };
      _otherDepositDetails[values.odepLogic.otherDepositName][
        this.state.currentIndex
      ].milestones = this.state.milestones;
      this.setState({
        otherDepositDetails: _otherDepositDetails,
      });
      this.state.periodTermDD = 0;
      this.state.periodTermMM = 0;
      this.state.periodTermYY = 0;
      this.state.fromDate = "";
      this.state.toDate = "";
      this.state.period = "";
      this.state.milestonesCount = 1;
      resetForm();
      this.validator.hideMessages();
      this.state.milestones = [];
      this.state.disableOnEdit = false;
      this.state.currentIndex = null;
      this.state.readOnEdit = false;
    }
  };

  resetDetails = (values, resetForm) => {
    this.state.periodTermDD = 0;
    this.state.periodTermMM = 0;
    this.state.periodTermYY = 0;
    this.state.fromDate = "";
    this.state.toDate = "";
    this.state.period = "";
    this.state.milestonesCount = 1;
    resetForm();
    this.validator.hideMessages();
    this.state.milestones = [];
    this.state.disableOnEdit = false;
    this.state.currentIndex = null;
    this.state.readOnEdit = false;
  };

  calculateDepositAmount(values) {
    if (values.odepLogic.otherDepositName === "Storage Deposit") {
      if (values.odepLogic.rateUOM === "Flat rate") {
        console.log("111");
        values.odepLogic.amount =
          formatTwoDecimal(values.odepLogic.rate * values.odepLogic.monthsCount);
        this.setState({});
      } else {
        values.odepLogic.amount =
          formatTwoDecimal(
            Number(values.odepLogic.rate) *
            Number(values.odepLogic.area) *
            Number(values.odepLogic.monthsCount)
          );
        this.setState({});
      }
    } else if (values.odepLogic.otherDepositName === "Fitout Deposit") {
      console.log("111");
      if (values.odepLogic.onArea === "Carpet Area") {
        values.odepLogic.amount =
          formatTwoDecimal(
            Number(values.odepLogic.rate) *
            Number(values.totalCarpetArea) *
            Number(values.odepLogic.monthsCount)
          );
        this.setState({});
      } else if (values.odepLogic.onArea === "Usable Area") {
        values.odepLogic.amount =
          formatTwoDecimal(
            Number(values.odepLogic.rate) *
            Number(values.totalUsableArea) *
          Number(values.odepLogic.monthsCount));
        this.setState({});
      } else if (values.odepLogic.onArea === "Gross Leasable Area") {
        values.odepLogic.amount =
          formatTwoDecimal(
            Number(values.odepLogic.rate) *
            Number(values.totalGrossLeasableArea) *
          Number(values.odepLogic.monthsCount));
        this.setState({});
      } else {
        values.odepLogic.amount =
          formatTwoDecimal(values.odepLogic.rate * values.odepLogic.monthsCount);
        this.setState({});
      }
    } else if (values.odepLogic.otherDepositName === "Other") {
      if (values.odepLogic.rate != "" && values.odepLogic.monthsCount != "") {
        values.odepLogic.amount =
          formatTwoDecimal(values.odepLogic.rate * values.odepLogic.monthsCount);
        this.setState({});
      }
    } else {
      values.odepLogic.amount =
        formatTwoDecimal(values.odepLogic.rate * values.odepLogic.onUnits);
      this.setState({});
    }
    if (this.state.period > 1) {
      this.calculateMilestoneAmount(1, values, 0);
    }
  }

  changeFieldName(e, id, values) {
    if (e.target.value == "Due on Lease Commencement Date") {
      this.state.milestones[id].dueDate = this.state.leaseCommencementDate;
      values.odepLogic.milestones[id].dueDate =
        this.state.leaseCommencementDate;
    } else {
      this.state.milestones[id].dueDate = "";
      values.odepLogic.milestones[id].dueDate = "";
    }
    if (e.target.value.includes("Escalation")) {
      this.state.milestones[id].milestoneQuantityType = "ODEP Milestone %";
    } else {
      this.state.milestones[id].milestoneQuantityType =
        "ODEP Milestone # Months";
    }
  }

  calculateMilestoneAmount(e, values, id) {
    if (this.state.period === 1) {
      var previousAmount = 0;
      var currentAmount = values.odepLogic.amount;
      var balanceAmount = currentAmount - previousAmount;
      console.log(previousAmount, currentAmount, balanceAmount);
      this.state.milestones[id].amount =
        (balanceAmount / 100) * this.state.milestones[id].milestonePercent;
      values.odepLogic.milestones[id].amount = this.state.milestones[id].amount;
      this.setState({});
    } else {
      var previousAmount =
        this.state.otherDepositDetails[values.odepLogic.otherDepositName][
          this.state.otherDepositDetails[values.odepLogic.otherDepositName]
            .length - 1
        ].amount;
      var currentAmount = values.odepLogic.amount;
      var balanceAmount = currentAmount - previousAmount;
      this.state.milestones[id].amount = (balanceAmount / 100) * 100;
      values.odepLogic.milestones[id].amount = formatTwoDecimal(this.state.milestones[id].amount);
      this.setState({});
    }
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  redirectToDelete = () => {
    var _odd = this.state.otherDepositDetails;
    _odd[this.state.keyvalue].splice(this.state.index_val, 1);
    this.setState({
      otherDepositDetails: _odd,
      showForm: true,
    });
    this.state.period--;
    this.setState({
      delete: false,
      index_val: "",
      keyvalue: "",
    });
  };

  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  milestoneTabs(handleChange, values) {
    var heads = [];
    for (var i = 0; i < this.state.milestonesCount; i++) {
      heads.push(<Tab>ODEP Milestone {i + 1}</Tab>);
    }

    var body = [];
    for (var i = 0; i < this.state.milestonesCount; i++) {
      if (
        typeof this.state.milestones[i] === "undefined" ||
        this.state.milestones[i] === null
      ) {
        this.state.milestones[i] = {};
        this.state.milestones[i].milestoneName = "";
        this.state.milestones[i].dueDate = "";
        this.state.milestones[i].milestonePercent = "";
        this.state.milestones[i].amount = "";
        this.state.milestones[i].milestoneQuantityType =
          "ODEP Milestone # Months";
        values.odepLogic.milestones[i] = {};
        values.odepLogic.milestones[i].milestoneName = "";
        values.odepLogic.milestones[i].dueDate = "";
        values.odepLogic.milestones[i].milestonePercent = "";
        values.odepLogic.milestones[i].amount = "";
      }
      body.push(
        <TabPanel>
          <div className="newGridSectionForFormMain">

            <div className="newGridSectionInner">
              <label>
                ODEP Milestone Name <span className="astrik">*</span>
              </label>
              <div className="position-relative">
                <select
                  param={i}
                  name={"odepLogic.milestones[" + i + "].milestoneName"}
                  value={this.state.milestones[i].milestoneName}
                  onChange={(e) => {
                    var id = e.target.getAttribute("param");
                    this.state.milestones[id].milestoneName = e.target.value;
                    this.changeFieldName(e, id, values);
                    handleChange(e);
                  }}
                >
                  <option value="" label="Select" defaultValue />
                  {this.state.milestoneNamesValues.map((item, i) => (
                    <option key={"milestoneNamesValues" + item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {this.validator.message(
                  "Milestone Name",
                  this.state.milestones[i].milestoneName,
                  "required",
                  { className: "text-danger" }
                )}
              </div>
            </div>

            <div className="newGridSectionInner">
              <label>
                Due Date <span className="astrik">*</span>
              </label>
              <div className="position-relative">
                <Field
                  type="date"
                  param={i}
                  value={this.state.milestones[i].dueDate}
                  name={"odepLogic.milestones[" + i + "].dueDate"}
                  onChange={(e) => {
                    var id = e.target.getAttribute("param");
                    this.state.milestones[id].dueDate = e.target.value;
                    handleChange(e);
                  }}
                ></Field>
                {this.validator.message(
                  "Due Date",
                  this.state.milestones[i].dueDate,
                  "required",
                  { className: "text-danger" }
                )}
              </div>
            </div>

            <div className="newGridSectionInner">
              <label>{this.state.milestoneMonths}</label>
              <div className="position-relative">
                <Field
                  param={i}
                  type="text"
                  name={"odepLogic.milestones[" + i + "].milestonePercent"}
                  value={
                    this.state.period === 1
                      ? this.state.milestones[i].milestonePercent
                      : 100
                  }
                  readOnly={this.state.period === 1 ? false : true}
                  onChange={(e) => {
                    var id = e.target.getAttribute("param");
                    this.state.milestones[id].milestonePercent = e.target.value;
                    handleChange(e);
                  }}
                  onBlur={(e) => {
                    var id = e.target.getAttribute("param");
                    this.calculateMilestoneAmount(e, values, id);
                  }}
                />
              </div>
            </div>

            <div className="newGridSectionInner">
              <label>
                ODEP Milestone Amount (Rs.) <span className="astrik">*</span>
              </label>
              <div className="position-relative">
                <Field
                  type="text"
                  name={"odepLogic.milestones[" + i + "].amount"}
                  param={i}
                  value={this.state.milestones[i].amount}
                  onChange={(e) => {
                    var id = e.target.getAttribute("param");
                    this.state.milestones[id].amount = e.target.value;
                    handleChange(e);
                  }}
                />
                <ErrorMessage
                  name={"odepLogic.milestones[" + i + "].amount"}
                  component="div"
                  className="text-red"
                />
              </div>
            </div>

          </div>
        </TabPanel>
      );
    }

    return (
      <div>
        <Tabs>
          <TabList>{heads}</TabList>
          <div>{body}</div>
        </Tabs>
      </div>
    );
  }

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match.path;
      let urlPath = url.split("/");
      this.state.redirect = false;
      return (
        <Redirect
          push
          //to={"/createlease/upload-document/" + this.props.match.params.id}
          to={`/${urlPath[1]}/upload-document/` + this.props.match.params.id}
        />
      );
    }
    return (
      <div
        className="parentContainer createLease"

      >
        <div>
          <div>
            <div className="absoluteItemForTopBar">
              <div className="new_breadcrumbs_design">
                <ul className="d-flex align-items-center gap-3 p-0 m-0">
                  <li>Create Lease</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>Security Deposit Details</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>
                    <a href="#">Other Deposit Details</a>
                  </li>
                </ul>
              </div>
            </div>


            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {
                values.otherDepositApplicable = this.state.applicableValue;
                if (!this.applicableValidator.allValid()) {
                  this.applicableValidator.showMessages();
                  return false;
                }
                // if (this.state.otherDepositDetails.length == 0) {
                //   this.mainFormValidator.showMessages("countError");
                //   return false;
                // }
                let count = 0;
                for (var key in this.state.otherDepositDetails) {
                  count = 1;
                  break;
                }
                if (count == 0 && this.state.applicableValue !== "no") {
                  this.mainFormValidator.showMessages("countError");
                  return false;
                }
                var otherDepositDetails = { ...this.state.otherDepositDetails };
                values.otherDepositDetails = otherDepositDetails;
                console.log(values, "gg");
                var self = this;
                axios({
                  method: "post",
                  url: `${apiUrl.apiUrl.url}/create-lease/update-lease-other-deposit-details?lease_id=${this.props.match.params.id}`,
                  data: values,
                }).then(function (response) {
                  if (!response.data.success) {
                    actions.setSubmitting(false);
                    actions.setErrors(response.data);
                  } else {
                    self.setState({ messsagePopup: true });
                  }
                });
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
                resetForm,
                setFieldValue,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off"className="customTabs">
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">
                          {this.state.showForm && (
                            <>
                              <div className="newGridSectionInner">
                                <label>
                                  Lease Term (YY-MM-DD) <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <div className="row m-0">
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="leaseTermYY"
                                        placeholder="YY"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermYY}
                                      />

                                    </div>
                                    <div className="col-sm-4">
                                      <Field
                                        type="text"
                                        name="leaseTermMM"
                                        placeholder="MM"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermMM}
                                      />

                                    </div>
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="leaseTermDD"
                                        placeholder="DD"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermDD}
                                      />

                                    </div>
                                  </div>
                                  <ErrorMessage
                                    name="leaseTerm"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>
                                  Lease Renewal Term (YY-MM-DD) <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <div className="row m-0">
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermYY"
                                        placeholder="YY"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermYY}
                                      />

                                    </div>
                                    <div className="col-sm-4">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermMM"
                                        placeholder="MM"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermMM}
                                      />

                                    </div>
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermDD"
                                        placeholder="DD"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermDD}
                                      />

                                    </div>
                                  </div>
                                  <ErrorMessage
                                    name="leaseRenewalTerm"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>From</label>
                                <div className="position-relative">
                                  <Field type="date" name="from" />
                                  <ErrorMessage
                                    name="from"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>To</label>
                                <div className="position-relative">
                                  <Field type="date" name="to" />
                                  <ErrorMessage
                                    name="to"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>
                                  Other Deposit Applicable <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name="otherDepositApplicable"
                                    value={this.state.applicableValue}
                                    onChange={(e) => {
                                      this.state.applicableValue = e.target.value;
                                      this.showOdForm(e);
                                      handleChange(e);
                                    }}
                                  >
                                    <option value="" label="Select" defaultValue />
                                    <option value="yes" label="Yes" />
                                    <option value="no" label="No" />
                                  </Field>
                                  {this.applicableValidator.message(
                                    "Other Deposit Applicable",
                                    this.state.applicableValue,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>

                              {this.state.toggleOdForm && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>
                                      Other Deposit Name (ODEP) <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="odepLogic.otherDepositName"
                                        disabled={this.state.disableOnEdit}
                                        onChange={(e) => {
                                          if (this.getDepositName(e, values, setFieldValue)) {
                                            handleChange(e);
                                          }
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option
                                          value="Electricity Load Deposit – Refundable"
                                          label="Electricity Load Deposit – Refundable"
                                        />
                                        <option
                                          value="Electricity Load Deposit – Non Refundable"
                                          label="Electricity Load Deposit – Non Refundable"
                                        />
                                        <option value="GAS / PNG Meter" label="GAS / PNG Meter" />
                                        <option
                                          value="GAS / PNG Connection Deposit"
                                          label="GAS / PNG Connection Deposit"
                                        />
                                        <option
                                          value="Electricity Meter Deposit"
                                          label="Electricity Meter Deposit"
                                        />
                                        <option value="Water Meter Deposit" label="Water Meter Deposit" />
                                        <option
                                          value="Air Conditioing Load Deposit"
                                          label="Air Conditioing Load Deposit"
                                        />
                                        <option
                                          value="Air Conditioning Meter Deposit"
                                          label="Air Conditioning Meter Deposit"
                                        />
                                        <option value="Fitout Deposit" label="Fitout Deposit" />
                                        <option value="Storage Deposit" label="Storage Deposit" />
                                        <option value="Other" label="Other" />
                                      </Field>
                                      {this.validator.message(
                                        "Other Deposit Nature",
                                        values.odepLogic.otherDepositName,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      Deposit Nature <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="odepLogic.depositNature"
                                        disabled={this.state.disableOnEdit}
                                        onChange={(e) => handleChange(e)}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option
                                          value="Refundable - Interest Free"
                                          label="Refundable - Interest Free"
                                        />
                                        <option
                                          value="Refundable - Interest Bearing"
                                          label="Refundable - Interest Bearing"
                                        />
                                        <option
                                          value="Non Refundable - Interest Free"
                                          label="Non Refundable - Interest Free"
                                        />
                                        <option
                                          value="Non Refundable - Interest Bearing"
                                          label="Non Refundable - Interest Bearing"
                                        />
                                      </Field>
                                      {this.validator.message(
                                        "Deposit Nature",
                                        values.odepLogic.depositNature,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  {values.odepLogic.otherDepositName !== "" && (
                                    <>
                                      <div className="newGridSectionInner">
                                        <label>
                                          Period
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="text"
                                            name="odepLogic.period"
                                            value={this.state.period}
                                            disabled={this.state.disableOnEdit}
                                            onChange={(e) => {
                                              this.setState({ period: e.target.value });
                                            }}
                                          />
                                          <ErrorMessage
                                            name="odepLogic.period"
                                            component="div"
                                            className="text-red"
                                          />
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          Period Term
                                        </label>
                                        <div className="position-relative">
                                          <div className="row m-0">
                                            <div className="col-sm-4 p-0">
                                              <Field
                                                type="text"
                                                name="periodTermYY"
                                                placeholder="YY"
                                                className="centerPlaceHolder"
                                                disabled={this.state.disableOnEdit}
                                                value={this.state.periodTermYY}
                                                onChange={(e) => {
                                                  this.setState({ periodTermYY: e.target.value });
                                                  handleChange(e);
                                                }}
                                                onBlur={(e) => {
                                                  this.calculateToDate(e);
                                                }}
                                              />
                                            </div>
                                            <div className="col-sm-4">
                                              <Field
                                                type="text"
                                                name="periodTermMM"
                                                placeholder="MM"
                                                className="centerPlaceHolder"
                                                disabled={this.state.disableOnEdit}
                                                value={this.state.periodTermMM}
                                                onChange={(e) => {
                                                  this.setState({ periodTermMM: e.target.value });
                                                  handleChange(e);
                                                }}
                                                onBlur={(e) => {
                                                  this.calculateToDate(e);
                                                }}
                                              />
                                            </div>
                                            <div className="col-sm-4 p-0">
                                              <Field
                                                type="text"
                                                name="periodTermDD"
                                                placeholder="DD"
                                                className="centerPlaceHolder"
                                                disabled={this.state.disableOnEdit}
                                                value={this.state.periodTermDD}
                                                onChange={(e) => {
                                                  this.setState({ periodTermDD: e.target.value });
                                                  handleChange(e);
                                                }}
                                                onBlur={(e) => {
                                                  this.calculateToDate(e);
                                                }}
                                              />
                                            </div>
                                          </div>
                                          <ErrorMessage
                                            name="mfLogic.periodTerm"
                                            component="div"
                                            className="text-red"
                                          />
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner"></div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="date"
                                            readOnly={this.state.readOnEdit}
                                            name="odepLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="date"
                                            readOnly={this.state.readOnEdit}
                                            name="odepLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          Deposit Rate UOM <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="odepLogic.rateUOM"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            {this.state.depositRateUomValues.map((item) => (
                                              <option key={"depositRateUomValues" + item} value={item}>
                                                {item}
                                              </option>
                                            ))}
                                          </Field>
                                          {this.validator.message(
                                            "ODEP Rate UOM",
                                            values.odepLogic.rateUOM,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          Deposit Rate
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="odepLogic.rate"
                                            onBlur={(e) => {
                                              this.calculateDepositAmount(values);
                                            }}
                                          />
                                          {this.validator.message(
                                            "Deposit Rate",
                                            values.odepLogic.rate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      {this.state.toggleOnUnit === true && (
                                        <div className="newGridSectionInner">
                                          <label>
                                            On Units
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              type="text"
                                              name="odepLogic.onUnits"
                                              onBlur={(e) => {
                                                this.calculateDepositAmount(values);
                                              }}
                                            />
                                            {this.validator.message(
                                              "On Units",
                                              values.odepLogic.onUnits,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      {this.state.showArea && values.odepLogic.rateUOM === "Per Sq.ft" && (
                                        <div className="newGridSectionInner">
                                          <label>
                                            Area
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              type="text"
                                              name="odepLogic.area"
                                              onBlur={(e) => {
                                                this.calculateDepositAmount(values);
                                              }}
                                            />
                                            {this.validator.message(
                                              "Area",
                                              values.odepLogic.area,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      {values.odepLogic.rateUOM === "Per Sq.ft" && (
                                        <div className="newGridSectionInner">
                                          <label>
                                            On Area
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              as="select"
                                              name="odepLogic.onArea"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Carpet Area" label="Carpet Area" />
                                              <option value="Usable Area" label="Usable Area" />
                                              <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                            </Field>
                                            {this.validator.message(
                                              "On Area",
                                              values.odepLogic.onArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      {this.state.toggleStorage && (
                                        <div className="newGridSectionInner">
                                          <label>
                                            No. of Months
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              type="text"
                                              name="odepLogic.monthsCount"
                                              onBlur={(e) => {
                                                this.calculateDepositAmount(values);
                                              }}
                                            />
                                            {this.validator.message(
                                              "No. of Months",
                                              values.odepLogic.monthsCount,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      <div className="newGridSectionInner">
                                        <label>
                                          Deposit Amount (Rs) <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="text"
                                            name="odepLogic.amount"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          <ErrorMessage
                                            name="odepLogic.amount"
                                            component="div"
                                            className="text-red"
                                          />
                                        </div>
                                      </div>

                                      {values.odepLogic.otherDepositName === "Other" && (
                                        <div className="newGridSectionInner">
                                          <label>
                                            Other Deposit Type <span className="astrik">*</span>
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              type="text"
                                              name="odepLogic.other_deposit_type"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            />
                                            <ErrorMessage
                                              name="odepLogic.other_deposit_type"
                                              component="div"
                                              className="text-red"
                                            />
                                          </div>
                                        </div>
                                      )}

                                      <div className="newGridSectionInner">
                                        <label>
                                          ODEP Milestones Count
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="text"
                                            name="odepLogic.milestonesCount"
                                            value={
                                              this.state.period === 1
                                                ? this.state.milestonesCount
                                                : 1
                                            }
                                            readOnly={
                                              this.state.period === 1
                                                ? false
                                                : true
                                            }
                                            onChange={(e) => {
                                              if (!isNaN(e.target.value)) {
                                                this.setState({
                                                  milestonesCount:
                                                    e.target.value,
                                                });
                                              }
                                            }}
                                          />
                                          <ErrorMessage
                                            name="odepLogic.milestonesCount"
                                            component="div"
                                            className="text-red"
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                          {values.odepLogic.otherDepositName !== "" && (
                            <div className="gridColOneByThree depositNature">
                              {this.state.showForm && (
                                <div className="unitFormContainerNew rentButtons">
                                  {this.milestoneTabs(handleChange, values)}
                                  <div className="button_group mt-3 d-flex align-items-center gap-2 justify-content-end">
                                    <button
                                      className="add_button"
                                      type="button"
                                      onClick={(e) => {
                                        this.addDetails(values, resetForm);
                                      }}
                                    >
                                      Add
                                    </button>
                                    <button
                                      className="reset_button"
                                      type="reset"
                                      onClick={(e) => {
                                        this.resetDetails(values, resetForm);
                                      }}
                                    >
                                      Reset
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                          <div className="gridColOneByThree">
                            <span className="remarks">Notes/Remarks</span>
                            <Field as="textarea" className="notes" name="notes_13" />
                          </div>
                        </div>
                        {this.mainFormValidator.message(
                          "Other Deposit Details",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Period</th>
                                <th scope="col">Period Term</th>
                                <th scope="col">From</th>
                                <th scope="col">To</th>
                                <th scope="col">Other Deposit Details</th>
                                <th scope="col">Total Amount</th>
                                <th scope="col" colSpan="2">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.keys(this.state.otherDepositDetails).map(
                                function (key, index1) {
                                  return this.state.otherDepositDetails[key].map(
                                    function (name, index) {
                                      return (
                                        <tr key={"mfTable" + index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            <a
                                              className="popupLink"
                                              onClick={(e) => {
                                                this.state.popupData = name;
                                                this.openModal();
                                              }}
                                            >
                                              {name.period}
                                            </a>
                                          </td>
                                          <td>
                                            {name.periodTermYY == ""
                                              ? "0"
                                              : name.periodTermYY}
                                            {"-"}
                                            {name.periodTermMM == ""
                                              ? "0"
                                              : name.periodTermMM}
                                            {"-"}
                                            {name.periodTermDD == ""
                                              ? "0"
                                              : name.periodTermDD}
                                          </td>
                                          <td>
                                            {/* {dateFormat(
                                            name.fromDate,
                                            "dd mmm yyyy"
                                          )} */}
                                            {leaseDateFormat(name.fromDate)}
                                          </td>
                                          <td>
                                            {/* {dateFormat(
                                            name.toDate,
                                            "dd mmm yyyy"
                                          )} */}
                                            {leaseDateFormat(name.toDate)}
                                          </td>
                                          <td>
                                            {name.otherDepositName}
                                            {`(`}
                                            {name.depositNature} {`)`}
                                          </td>
                                          <td>{ formatTwoDecimal(name.totalAmount || name.amount || 0)}</td>
                                          <td>
                                            {/* <button
                                            type="button"
                                            className="tableActionEdit rentalEdit"
                                            onClick={(e) => {
                                              this.editOd(index, values, key);
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faPen} />
                                          </button> */}
                                            {this.state.otherDepositDetails[key]
                                              .length ==
                                              index + 1 && (
                                                <button
                                                  type="button"
                                                  className="actionDelete rentalDeleteButton"
                                                  onClick={(e) => {
                                                    // if (
                                                    //   window.confirm(
                                                    //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                                    //   )
                                                    // ) {
                                                    //   var _odd =
                                                    //     this.state
                                                    //       .otherDepositDetails;
                                                    //   _odd[key].splice(index, 1);
                                                    //   this.setState({
                                                    //     otherDepositDetails: _odd,
                                                    //     showForm: true,
                                                    //   });
                                                    //   this.state.period--;
                                                    // }
                                                    this.setState({
                                                      delete: true,
                                                      index_val: index,
                                                      keyvalue: key,
                                                    });
                                                  }}
                                                >
                                                  <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                              )}
                                          </td>
                                        </tr>
                                      );
                                    },
                                    this
                                  );
                                },
                                this
                              )}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                  {/* <div className="unitFormContainerNew">
                    <Form className="customTabs">
                      <div className="newGridSectionParent">
                        {this.state.showForm && (
                          <div className="unitFormContainerNew leaseSection mb-4">
                            <div className="container">
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Lease Term (YY-MM-DD){" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-3 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="leaseTermYY"
                                          placeholder="YY"
                                          className="centerPlaceHolder"
                                          value={this.state.leaseTermYY}
                                        />
                                      </div>
                                      <div className="col-sm-2 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="leaseTermMM"
                                          placeholder="MM"
                                          className="centerPlaceHolder"
                                          value={this.state.leaseTermMM}
                                        />
                                      </div>
                                      <div className="col-sm-2 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="leaseTermDD"
                                          placeholder="DD"
                                          className="centerPlaceHolder"
                                          value={this.state.leaseTermDD}
                                        />
                                      </div>
                                      <ErrorMessage
                                        name="leaseTerm"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Lease Renewal Term (YY-MM-DD){" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-3 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="leaseRenewalTermYY"
                                          placeholder="YY"
                                          className="centerPlaceHolder"
                                          value={this.state.renewalLeaseTermYY}
                                        />
                                      </div>
                                      <div className="col-sm-2 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="leaseRenewalTermMM"
                                          placeholder="MM"
                                          className="centerPlaceHolder"
                                          value={this.state.renewalLeaseTermMM}
                                        />
                                      </div>
                                      <div className="col-sm-2 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="leaseRenewalTermDD"
                                          placeholder="DD"
                                          className="centerPlaceHolder"
                                          value={this.state.renewalLeaseTermDD}
                                        />
                                      </div>
                                      <ErrorMessage
                                        name="leaseRenewalTerm"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        From
                                      </label>
                                      <div className="col-sm-7">
                                        <Field type="date" name="from" />
                                        <ErrorMessage
                                          name="from"
                                          component="div"
                                          className="text-red"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        To
                                      </label>
                                      <div className="col-sm-7">
                                        <Field type="date" name="to" />
                                        <ErrorMessage
                                          name="to"
                                          component="div"
                                          className="text-red"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Other Deposit Applicable{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          as="select"
                                          name={"otherDepositApplicable"}
                                          value={this.state.applicableValue}
                                          onChange={(e) => {
                                            this.state.applicableValue =
                                              e.target.value;
                                            this.showOdForm(e);
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option value="yes" label="Yes" />
                                          <option value="no" label="No" />
                                        </Field>
                                        {this.applicableValidator.message(
                                          "Other Deposit Applicable",
                                          this.state.applicableValue,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {this.state.toggleOdForm && (
                                <div className="odApplicable">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Other Deposit Name (ODEP)
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"odepLogic.otherDepositName"}
                                              disabled={this.state.disableOnEdit}
                                              onChange={(e) => {
                                                if (
                                                  // this.loadDepositRateUomValues(e);
                                                  this.getDepositName(
                                                    e,
                                                    values,
                                                    setFieldValue
                                                  )
                                                ) {
                                                  handleChange(e);
                                                }
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Electricity Load Deposit – Refundable"
                                                label="Electricity Load Deposit – Refundable"
                                              />
                                              <option
                                                value="Electricity Load Deposit – Non Refundable"
                                                label="Electricity Load Deposit – Non Refundable"
                                              />
                                              <option
                                                value="GAS / PNG Meter"
                                                label="GAS / PNG Meter"
                                              />
                                              <option
                                                value="GAS / PNG Connection Deposit"
                                                label="GAS / PNG Connection Deposit"
                                              />
                                              <option
                                                value="Electricity Meter Deposit"
                                                label="Electricity Meter Deposit"
                                              />
                                              <option
                                                value="Water Meter Deposit"
                                                label="Water Meter Deposit"
                                              />
                                              <option
                                                value="Air Conditioing Load Deposit"
                                                label="Air Conditioing Load Deposit"
                                              />
                                              <option
                                                value="Air Conditioning Meter Deposit"
                                                label="Air Conditioning Meter Deposit"
                                              />
                                              <option
                                                value="Fitout Deposit"
                                                label="Fitout Deposit"
                                              />
                                              <option
                                                value="Storage Deposit"
                                                label="Storage Deposit"
                                              />
                                              <option value="Other" label="Other" />
                                            </Field>
                                            {this.validator.message(
                                              "Other Deposit Nature",
                                              values.odepLogic.otherDepositName,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Deposit Nature
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"odepLogic.depositNature"}
                                              disabled={this.state.disableOnEdit}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Refundable - Interest Free"
                                                label="Refundable - Interest Free"
                                              />
                                              <option
                                                value="Refundable - Interest Bearing"
                                                label="Refundable - Interest Bearing"
                                              />
                                              <option
                                                value="Non Refundable - Interest Free"
                                                label="Non Refundable - Interest Free"
                                              />
                                              <option
                                                value="Non Refundable - Interest Bearing"
                                                label="Non Refundable - Interest Bearing"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "Deposit Nature",
                                              values.odepLogic.depositNature,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {values.odepLogic.otherDepositName !== "" && (
                                    <div className="depositNature">
                                      <div className="row">
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                Period
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  type="text"
                                                  name="odepLogic.period"
                                                  value={this.state.period}
                                                  disabled={this.state.disableOnEdit}
                                                  onChange={(e) => {
                                                    this.state.period =
                                                      e.target.value;
                                                  }}
                                                />
                                                <ErrorMessage
                                                  name="odepLogic.period"
                                                  component="div"
                                                  className="text-red"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                Period Term
                                              </label>
                                              <div className="col-sm-3 leaseTermFieldWidth">
                                                <Field
                                                  type="text"
                                                  name="periodTermmYY"
                                                  placeholder="YY"
                                                  className="centerPlaceHolder"
                                                  disabled={this.state.disableOnEdit}
                                                  value={this.state.periodTermYY}
                                                  onChange={(e) => {
                                                    this.state.periodTermYY =
                                                      e.target.value;
                                                    handleChange(e);
                                                  }}
                                                  onBlur={(e) => {
                                                    this.calculateToDate(e);
                                                  }}
                                                />
                                              </div>
                                              <div className="col-sm-2 leaseTermFieldWidth">
                                                <Field
                                                  type="text"
                                                  name="periodTermMM"
                                                  placeholder="MM"
                                                  className="centerPlaceHolder"
                                                  disabled={this.state.disableOnEdit}
                                                  value={this.state.periodTermMM}
                                                  onChange={(e) => {
                                                    this.state.periodTermMM =
                                                      e.target.value;
                                                    handleChange(e);
                                                  }}
                                                  onBlur={(e) => {
                                                    this.calculateToDate(e);
                                                  }}
                                                />
                                              </div>
                                              <div className="col-sm-2 leaseTermFieldWidth">
                                                <Field
                                                  type="text"
                                                  name="periodTermDD"
                                                  placeholder="DD"
                                                  className="centerPlaceHolder"
                                                  disabled={this.state.disableOnEdit}
                                                  value={this.state.periodTermDD}
                                                  onChange={(e) => {
                                                    this.state.periodTermDD =
                                                      e.target.value;
                                                    handleChange(e);
                                                  }}
                                                  onBlur={(e) => {
                                                    this.calculateToDate(e);
                                                  }}
                                                />
                                              </div>
                                              <ErrorMessage
                                                name="mfLogic.periodTerm"
                                                component="div"
                                                className="text-red"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>


                                      <div className="row">
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                From <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  type="date"
                                                  readOnly={this.state.readOnEdit}
                                                  name="odepLogic.fromDate"
                                                  value={this.state.fromDate}
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                />
                                                {this.validator.message(
                                                  "From",
                                                  this.state.fromDate,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                To <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  type="date"
                                                  readOnly={this.state.readOnEdit}
                                                  name="odepLogic.toDate"
                                                  value={this.state.toDate}
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                />
                                                {this.validator.message(
                                                  "To",
                                                  this.state.toDate,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                Deposit Rate UOM
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  as="select"
                                                  name={"odepLogic.rateUOM"}
                                                  onChange={(e) => {
                                                    // this.validator =
                                                    //   new SimpleReactValidator({
                                                    //     autoForceUpdate: this,
                                                    //   });
                                                    handleChange(e);
                                                  }}
                                                >
                                                  <option
                                                    value=""
                                                    label="Select"
                                                    defaultValue
                                                  />
                                                  {this.state.depositRateUomValues.map(
                                                    (item, i) => (
                                                      <option
                                                        key={
                                                          "depositRateUomValues" +
                                                          item
                                                        }
                                                        value={item}
                                                      >
                                                        {item}
                                                      </option>
                                                    )
                                                  )}
                                                </Field>
                                                {this.validator.message(
                                                  "ODEP Rate UOM",
                                                  values.odepLogic.rateUOM,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                Deposit Rate
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  type="number"
                                                  name="odepLogic.rate"
                                                  onBlur={(e) => {
                                                    this.calculateDepositAmount(
                                                      values
                                                    );
                                                  }}
                                                />
                                                {this.validator.message(
                                                  "Deposit Rate",
                                                  values.odepLogic.rate,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {this.state.toggleOnUnit === true && (
                                          <div className="col-lg-6">
                                            <div className="inputContainer col-lg-12 col-md-12">
                                              <div className="row mb-3">
                                                <label className="col-sm-4 col-form-label">
                                                  On Units
                                                </label>
                                                <div className="col-sm-7">
                                                  <Field
                                                    type="text"
                                                    name="odepLogic.onUnits"
                                                    onBlur={(e) => {
                                                      this.calculateDepositAmount(
                                                        values
                                                      );
                                                    }}
                                                  />
                                                  {this.validator.message(
                                                    "On Units",
                                                    values.odepLogic.onUnits,
                                                    "required",
                                                    { className: "text-danger" }
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                        {this.state.showArea &&
                                          values.odepLogic.rateUOM ===
                                          "Per Sq.ft" && (
                                            <div className="col-lg-6">
                                              <div className="inputContainer col-lg-12 col-md-12">
                                                <div className="row mb-3">
                                                  <label className="col-sm-4 col-form-label">
                                                    Area
                                                  </label>
                                                  <div className="col-sm-7">
                                                    <Field
                                                      type="text"
                                                      name="odepLogic.area"
                                                      onBlur={(e) => {
                                                        this.calculateDepositAmount(
                                                          values
                                                        );
                                                      }}
                                                    />
                                                    {this.validator.message(
                                                      "Area",
                                                      values.odepLogic.area,
                                                      "required",
                                                      { className: "text-danger" }
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        {values.odepLogic.rateUOM == "Per Sq.ft" && (
                                          <div className="col-lg-6">
                                            <div className="inputContainer col-lg-12 col-md-12">
                                              <div className="row mb-3">
                                                <label className="col-sm-4 col-form-label">
                                                  On Area
                                                </label>
                                                <div className="col-sm-7">
                                                  <Field
                                                    as="select"
                                                    name={"odepLogic.onArea"}
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                  >
                                                    <option
                                                      value=""
                                                      label="Select"
                                                      defaultValue
                                                    />
                                                    <option
                                                      value="Carpet Area"
                                                      label="Carpet Area"
                                                    />
                                                    <option
                                                      value="Usable Area"
                                                      label="Usable Area"
                                                    />
                                                    <option
                                                      value="Gross Leasable Area"
                                                      label="Gross Leasable Area"
                                                    />
                                                  </Field>
                                                  {this.validator.message(
                                                    "On Area",
                                                    values.odepLogic.onArea,
                                                    "required",
                                                    { className: "text-danger" }
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                        {this.state.toggleStorage && (
                                          <div className="col-lg-6">
                                            <div className="inputContainer col-lg-12 col-md-12">
                                              <div className="row mb-3">
                                                <label className="col-sm-4 col-form-label">
                                                  No. of Months
                                                </label>
                                                <div className="col-sm-7">
                                                  <Field
                                                    type="text"
                                                    name="odepLogic.monthsCount"
                                                    onBlur={(e) => {
                                                      this.calculateDepositAmount(
                                                        values
                                                      );
                                                    }}
                                                  />
                                                  {this.validator.message(
                                                    "No. of Months",
                                                    values.odepLogic.monthsCount,
                                                    "required",
                                                    { className: "text-danger" }
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                Deposit Amount (Rs)
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  type="text"
                                                  name={"odepLogic.amount"}
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                ></Field>
                                                <ErrorMessage
                                                  name="odepLogic.amount"
                                                  component="div"
                                                  className="text-red"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {values.odepLogic.otherDepositName ==
                                          "Other" && (
                                            <div className="col-lg-6">
                                              <div className="inputContainer col-lg-12 col-md-12">
                                                <div className="row mb-3">
                                                  <label className="col-sm-4 col-form-label">
                                                    Other Deposit Type
                                                    <span className="astrik">*</span>
                                                  </label>
                                                  <div className="col-sm-7">
                                                    <Field
                                                      type="text"
                                                      name={
                                                        "odepLogic.other_deposit_type"
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                    ></Field>
                                                    <ErrorMessage
                                                      name="odepLogic.other_deposit_type"
                                                      component="div"
                                                      className="text-red"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                      <div className="row">
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                ODEP Milestones Count
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  type="text"
                                                  name="odepLogic.milestonesCount"
                                                  value={
                                                    this.state.period === 1
                                                      ? this.state.milestonesCount
                                                      : 1
                                                  }
                                                  readOnly={
                                                    this.state.period === 1
                                                      ? false
                                                      : true
                                                  }
                                                  onChange={(e) => {
                                                    if (!isNaN(e.target.value)) {
                                                      this.setState({
                                                        milestonesCount:
                                                          e.target.value,
                                                      });
                                                    }
                                                  }}
                                                />
                                                <ErrorMessage
                                                  name="odepLogic.milestonesCount"
                                                  component="div"
                                                  className="text-red"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        {values.odepLogic.otherDepositName !== "" && (
                          <div className="depositNature">
                            {this.state.showForm && (
                              <div className="unitFormContainerNew rentButtons">
                                {this.milestoneTabs(handleChange, values)}
                                <div className="button_group mt-3 d-flex align-items-center gap-2 justify-content-end">
                                  <button
                                    className="add_button"
                                    type="button"
                                    onClick={(e) => {
                                      this.addDetails(values, resetForm);
                                    }}
                                  >
                                    Add
                                  </button>
                                  <button
                                    className="reset_button"
                                    type="reset"
                                    onClick={(e) => {
                                      this.resetDetails(values, resetForm);
                                    }}
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        <div className="unitFormContainerNew">
                          <span className="remarks">Notes/Remarks</span>
                          <Field as="textarea" className="notes" name="notes_13" />
                        </div>
                        {this.mainFormValidator.message(
                          "Other Deposit Details",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Period</th>
                                <th scope="col">Period Term</th>
                                <th scope="col">From</th>
                                <th scope="col">To</th>
                                <th scope="col">Other Deposit Details</th>
                                <th scope="col">Total Amount</th>
                                <th scope="col" colSpan="2">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.keys(this.state.otherDepositDetails).map(
                                function (key, index1) {
                                  return this.state.otherDepositDetails[key].map(
                                    function (name, index) {
                                      return (
                                        <tr key={"mfTable" + index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            <a
                                              className="popupLink"
                                              onClick={(e) => {
                                                this.state.popupData = name;
                                                this.openModal();
                                              }}
                                            >
                                              {name.period}
                                            </a>
                                          </td>
                                          <td>
                                            {name.periodTermYY == ""
                                              ? "0"
                                              : name.periodTermYY}
                                            {"-"}
                                            {name.periodTermMM == ""
                                              ? "0"
                                              : name.periodTermMM}
                                            {"-"}
                                            {name.periodTermDD == ""
                                              ? "0"
                                              : name.periodTermDD}
                                          </td>
                                          <td>
                                            {leaseDateFormat(name.fromDate)}
                                          </td>
                                          <td>
                                            {leaseDateFormat(name.toDate)}
                                          </td>
                                          <td>
                                            {name.otherDepositName}
                                            {`(`}
                                            {name.depositNature} {`)`}
                                          </td>
                                          <td>{name.totalAmount || name.amount || "-"}</td>
                                          <td>
                                            {this.state.otherDepositDetails[key]
                                              .length ==
                                              index + 1 && (
                                                <button
                                                  type="button"
                                                  className="actionDelete rentalDeleteButton"
                                                  onClick={(e) => {
                                                    // if (
                                                    //   window.confirm(
                                                    //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                                    //   )
                                                    // ) {
                                                    //   var _odd =
                                                    //     this.state
                                                    //       .otherDepositDetails;
                                                    //   _odd[key].splice(index, 1);
                                                    //   this.setState({
                                                    //     otherDepositDetails: _odd,
                                                    //     showForm: true,
                                                    //   });
                                                    //   this.state.period--;
                                                    // }
                                                    this.setState({
                                                      delete: true,
                                                      index_val: index,
                                                      keyvalue: key,
                                                    });
                                                  }}
                                                >
                                                  <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                              )}
                                          </td>
                                        </tr>
                                      );
                                    },
                                    this
                                  );
                                },
                                this
                              )}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div> */}
                </>
              )}
            </Formik>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                size="lg"
                className="documentModal"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <div className="container modalBreadCrumbs">
                      <div className="row">
                        <div className="col-lg-12">
                          <ul>
                            <li>Other Deposit Details</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.isOpen &&
                    this.otherDepositDetailPopup(this.state.popupData)}
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
      </div>
    );
  }
  otherDepositDetailPopup(rent) {
    return this.otherDetailsPopup(rent);
  }
  otherDetailsPopup(rent) {
    console.log(rent);
    return (
      <div className="container">
        <div className="row">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{rent.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rent.periodTermYY == "" ? "0" : rent.periodTermYY}
                  {"-"}
                  {rent.periodTermMM == "" ? "0" : rent.periodTermMM}
                  {"-"}
                  {rent.periodTermDD == "" ? "0" : rent.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Deposit Nature (ODEP) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rent.otherDepositName} ({rent.depositNature})
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {/* {dateFormat(rent.fromDate, "dd mmm yyyy")} */}
                  {leaseDateFormat(rent.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {/* {dateFormat(rent.toDate, "dd mmm yyyy")} */}
                  {leaseDateFormat(rent.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Deposit Rate UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rent.rateUOM}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  ODEP # Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{rent.rate}</label>
              </div>
            </div>
          </div>
          {rent.otherDepositName !== "Storage Deposit" &&
            rent.otherDepositName !== "Fitout Deposit" && (
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      ODEP On Units <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {rent.onUnits}
                    </label>
                  </div>
                </div>
              </div>
            )}
          {rent.otherDepositName === "Storage Deposit" && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    No.of Months <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rent.monthsCount}
                  </label>
                </div>
              </div>
            </div>
          )}
          {rent.rateUOM === "Per Sq.ft" && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">{rent.area}</label>
                </div>
              </div>
            </div>
          )}
          {rent.otherDepositName === "Fitout Deposit" && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rent.onArea}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  ODEP Total Amount <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{formatTwoDecimal(rent.amount)}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  ODEP MileStones
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer p-0">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">Milestone Name</th>
                          <th scope="col">Due Date</th>
                          <th scope="col">RDEP Milestone</th>
                          <th scope="col">RDEP Milestone Amount (Rs.)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rent.milestones.length > 0 &&
                          rent.milestones.map((name, index) => (
                            <tr key={index}>
                              <td>{name.milestoneName}</td>
                              <td>
                                {/* {dateFormat(name.dueDate, "dd mmm yyyy")}{" "} */}
                                {leaseDateFormat(name.dueDate)}
                              </td>
                              <td>{name.milestonePercent}</td>
                              <td>{formatTwoDecimal(name.amount)}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(OtherDepositDetails);
